import { WORKLIST_STATUSES_DISPLAY } from '../constants';
import CustomButton from '@/new-components/CustomButton';
import CustomModalTitle from '@/new-components/CustomModal/CustomModalTitle';
import {
  Dialog,
  DialogActions,
  DialogContent,
  InputLabel,
  TextField,
  withStyles,
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

const CustomDialog = withStyles({
  paper: {
    borderRadius: 16,
    width: 480,
    overflowY: 'unset',
  },
})(Dialog);

const CustomDialogContent = withStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    overflowY: 'auto',
    maxHeight: '70vh',
  },
}))(DialogContent);

const CustomDialogActions = withStyles({
  root: {
    margin: 0,
    padding: 16,
    justifyContent: 'flex-end',
  },
})(DialogActions);

const CustomInputLabel = withStyles((theme) => ({
  root: {
    color: '#666666',
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
}))(InputLabel);

const CustomMultipleTextField = withStyles({
  root: {
    fontSize: 20,

    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      minHeight: 48,
    },
    '& .MuiOutlinedInput-input': {
      marginRight: 0,
      paddingLeft: 5,
      fontSize: 16,
      lineHeight: 1.5,
    },

    '& .MuiInputBase-inputMultiline': {
      '&.MuiInputBase-input': {
        marginLeft: 0,
      },
    },

    '& .Mui-disabled': {
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f6f6f6',
      },
    },

    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input':
      {
        padding: 0,
        paddingLeft: 4,
        marginLeft: 4,
        height: 30,
      },

    '& .MuiFormHelperText-contained': {
      marginLeft: 0,
    },
  },
})(TextField);

const ModalUpdateStatus = ({
  open,
  onClose,
  onSubmit,
  type,
  selectedItem,
  typeModal,
}) => {
  const [formValue, setFormValue] = useState({
    reason: '',
    reason2: '',
  });
  const [defaultFormValue, setDefaultFormValue] = useState({
    reason: '',
    reason2: '',
  });

  useEffect(() => {
    if (!selectedItem) return;
    setDefaultFormValue({
      reason: selectedItem.reason,
      reason2: selectedItem.reason2,
    });
    setFormValue({
      reason: selectedItem.reason,
      reason2: selectedItem.reason2,
    });
  }, [selectedItem]);

  const isDisabled = useMemo(() => {
    if (type === 'Contacted') return false;
    if (type === 'Unreachable') {
      return isEmpty(formValue.reason);
    }
    if (type === 'UnreachableAttempt2') {
      if (!isEmpty(defaultFormValue.reason)) {
        return isEmpty(formValue.reason) || isEmpty(formValue.reason2);
      } else {
        return isEmpty(formValue.reason2);
      }
    }
    return false;
  }, [type, formValue, defaultFormValue]);

  return (
    <CustomDialog
      scroll="body"
      disableEnforceFocus
      open={open}
      onClose={onClose}
      disableBackdropClick
    >
      <CustomModalTitle onClose={onClose}>
        {typeModal === 'ChangeStatus' ? (
          <>
            {type === 'Contacted'
              ? `Change "${
                  selectedItem.worklistStatus === 'Unreachable'
                    ? 'Unreachable + 1'
                    : 'Unreachable + 2'
                }" to "Contacted"`
              : 'Change "Unreachable + 1" to "Unreachable + 2"'}
          </>
        ) : (
          <>Update Status as "{WORKLIST_STATUSES_DISPLAY[type]}"</>
        )}
      </CustomModalTitle>
      <CustomDialogContent dividers>
        {type !== 'Contacted' ? (
          type === 'Unreachable' ? (
            <>
              <CustomInputLabel>Reason 1</CustomInputLabel>
              <CustomMultipleTextField
                rows={3}
                multiline
                fullWidth
                variant="outlined"
                placeholder="Enter details"
                value={formValue.reason}
                onChange={(e) => {
                  setFormValue({
                    ...formValue,
                    reason: e.target.value,
                  });
                }}
              />
            </>
          ) : typeModal === 'Add' ? (
            <>
              <CustomInputLabel>Reason 2</CustomInputLabel>
              <CustomMultipleTextField
                rows={3}
                multiline
                fullWidth
                variant="outlined"
                placeholder="Enter details"
                value={formValue.reason2}
                onChange={(e) => {
                  setFormValue({
                    ...formValue,
                    reason2: e.target.value,
                  });
                }}
              />
            </>
          ) : (
            <>
              {!isEmpty(defaultFormValue.reason) && (
                <>
                  <CustomInputLabel>Reason 1</CustomInputLabel>
                  <CustomMultipleTextField
                    rows={3}
                    multiline
                    fullWidth
                    variant="outlined"
                    placeholder="Enter details"
                    value={formValue.reason}
                    onChange={(e) => {
                      setFormValue({
                        ...formValue,
                        reason: e.target.value,
                      });
                    }}
                  />
                </>
              )}

              <CustomInputLabel
                style={{
                  marginTop: !isEmpty(defaultFormValue.reason) ? 16 : 0,
                }}
              >
                Reason 2
              </CustomInputLabel>
              <CustomMultipleTextField
                rows={3}
                multiline
                fullWidth
                variant="outlined"
                placeholder="Enter details"
                value={formValue.reason2}
                onChange={(e) => {
                  setFormValue({
                    ...formValue,
                    reason2: e.target.value,
                  });
                }}
              />
            </>
          )
        ) : (
          <>
            <CustomInputLabel>Reason 1</CustomInputLabel>
            <CustomMultipleTextField
              rows={3}
              multiline
              fullWidth
              variant="outlined"
              placeholder="Enter details"
              value={formValue.reason}
              onChange={(e) => {
                setFormValue({
                  ...formValue,
                  reason: e.target.value,
                });
              }}
            />
            {typeModal === 'ChangeStatus' && (
              <>
                <CustomInputLabel style={{ marginTop: 16 }}>
                  Reason 2
                </CustomInputLabel>
                <CustomMultipleTextField
                  rows={3}
                  multiline
                  fullWidth
                  variant="outlined"
                  placeholder="Enter details"
                  value={formValue.reason2}
                  onChange={(e) => {
                    setFormValue({
                      ...formValue,
                      reason2: e.target.value,
                    });
                  }}
                />
              </>
            )}
          </>
        )}
      </CustomDialogContent>

      <CustomDialogActions>
        <CustomButton
          type="submit"
          variant="contained"
          color="primary"
          onClick={() => onSubmit(formValue)}
          disabled={isDisabled}
        >
          Save
        </CustomButton>
      </CustomDialogActions>
    </CustomDialog>
  );
};

ModalUpdateStatus.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  selectedItem: PropTypes.object,
};

ModalUpdateStatus.defaultProps = {
  open: false,
  onClose: () => console.warn('Not implemented yet'),
  onSubmit: () => console.warn('Not implemented yet'),
  selectedItem: null,
};

export default ModalUpdateStatus;
